import React, { useState } from 'react';
import SGMSClient from '../../../js/SGMSClient';
import { store } from '../../../stores/store';
import './MeetingForm.css';


const MeetingForm = () => {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault()

    SGMSClient.meetingGetWithCode(code, SGMSClient.currentUser.UserLogin)
    .then(meeting => SGMSClient.meetingConnect(meeting))
    .then(() => store.secondLoad(SGMSClient.currentMeeting.Config))
    .catch(msg => setError(msg))

  }
  return (
    <div className="MeetingForm">
      <h3>{store.t("enter_meeting_code")}</h3>
      <form onSubmit={handleSubmit}>
        <p>
          <input
          type="text"
          id="code"
          required
          autoComplete="off"
          placeholder={store.t("meeting_code")}
          value={code}
          onChange={e => setCode(e.target.value)} />
        </p>
        <button>{store.t("play_button")}</button>
      </form>
      {error && <p className="error">{store.t("error_connect_multiplayer_game")}</p>}
    </div>
  );
};

export default MeetingForm;
